import React from 'react';
import * as PropTypes from 'prop-types';

const ErrorMessage = (props) => {
    if (props.isVisible) {
        return (
            <div
                className="alert alert-danger"
                role="alert"
                style={props.style}
            >
                <strong>Error - </strong> {props.message}
            </div>
        );
    } else return null;
};

ErrorMessage.propTypes = {
    isVisible: PropTypes.bool,
    message: PropTypes.string,
    style: PropTypes.object
};

export default ErrorMessage;